module.exports = __webpack_public_path__ + "img/m_top_reference.fc45eca7.jpg";